import React, { useState, useEffect, useMemo } from "react";
import { PiShoppingBag } from "react-icons/pi";
import { MdSupervisorAccount, MdAccessTime } from "react-icons/md";
import { FaRupeeSign } from "react-icons/fa";
import PartnerAnalysis from "./partnerAnalysis";
import { getPartnerAnalysis } from "../../../../Service/partnerAPI";
import { partnerPortalImages } from "../../../../reusableUI/images";
import { GrLocation } from "react-icons/gr";
import Loader from "../../../../reusableUI/loader";


const formatCurrency = (value) =>
    `₹${(Number(value) || 0).toLocaleString("en-IN")}`;


const SUMMARY_CARD_CONFIG = [
    {
        id: "totalPartners",
        key: "totalPartners",
        title: "Total Partners",
        accentClasses: "bg-blue-50 text-blue-500",
        icon: <PiShoppingBag />,
    },
    {
        id: "totalHCP",
        key: "totalHCP",
        title: "Total HCPs",
        accentClasses: "bg-emerald-50 text-emerald-500",
        icon: <MdSupervisorAccount />,
    },
    {
        id: "totalRevenue",
        key: "totalRevenue",
        title: "Total Revenue",
        accentClasses: "bg-purple-50 text-purple-500",
        icon: <FaRupeeSign />,
    },
    {
        id: "pendingAmount",
        key: "pendingAmount",
        title: "Pending Amount",
        accentClasses: "bg-amber-50 text-amber-500",
        icon: <MdAccessTime />,
    },
];


const SummaryCard = ({ title, value, icon, accentClasses }) => (
    <div className="bg-white rounded-[8px] shadow-sm border border-slate-100 px-4 py-6 flex items-center justify-between">
        <div className="flex flex-col gap-2">
            <p className="text-[16px] font-medium text-slate-500 font-poppins">
                {title}
            </p>
            <p className="mt-1 text-2xl font-semibold text-slate-900 font-poppins">
                {value}
            </p>
        </div>
        <div
            className={`w-10 h-10 rounded-[13px] flex items-center justify-center text-[18px] font-semibold ${accentClasses}`}
        >
            {icon}
        </div>
    </div>
);

const PartnerCard = ({ partner, onSelect }) => (
    <div className="bg-white rounded-[8px] shadow-sm border border-slate-100 px-4 py-5 flex items-center justify-between">

        <div className="flex items-center gap-3 flex-1 min-w-0">

            <div className="w-16 h-10 rounded-[6px] overflow-hidden bg-slate-100 flex items-center justify-center">
                {partner.bannerImage ? (
                    <img
                        src={partner.bannerImage || partnerPortalImages.partnerDefaultDp}
                        alt={"LOGO"}
                        className="w-full h-full object-cover"
                    />
                ) : (
                    <span className="text-[10px] font-semibold text-slate-500 font-poppins">
                        LOGO
                    </span>
                )}
            </div>

            <div className="min-w-0 flex flex-col gap-2">
                <div className="flex items-center gap-2">
                    <h3 className="text-sm font-semibold text-slate-900 truncate font-poppins">
                        {partner.name}
                    </h3>
                    <span className="w-1.5 h-1.5 rounded-full bg-emerald-500" />
                </div>

                <div className="mt-1 flex flex-wrap items-center gap-3 text-[11px] text-slate-500">


                    <span className="w-1 h-1 rounded-full bg-slate-300" />
                    <span>ID : {partner.referralCode}</span>

                    <>
                        <span className="w-1 h-1 rounded-full bg-slate-300" />
                        <div className="flex items-center gap-1">
                            <GrLocation size={14} color={"#4F46E5"} />
                            <span>{partner.city},{partner.state}</span>
                        </div>
                    </>

                </div>
            </div>
        </div>


        <div className="flex items-center gap-8 text-xs font-medium text-slate-600">
            <div className="text-right">
                <div className="flex items-center gap-2">
                    <MdSupervisorAccount />
                    <p className="uppercase tracking-wide text-[10px] text-slate-400 font-poppins">
                        Total HCPs
                    </p>
                </div>
                <p className="mt-1 text-sm font-semibold text-slate-900 font-poppins">
                    {partner.totalUsers ?? 0}
                </p>
            </div>

            <div className="text-right">
                <div className="flex items-center gap-2">
                    <PiShoppingBag />
                    <p className="uppercase tracking-wide text-[10px] text-slate-400 font-poppins">
                        Bookings
                    </p>
                </div>
                <p className="mt-1 text-sm font-semibold text-slate-900 font-poppins">
                    {partner.bookings ?? 0}
                </p>
            </div>

            <div className="text-right">
                <div className="flex items-center gap-2">
                    <FaRupeeSign />
                    <p className="uppercase tracking-wide text-[10px] text-slate-400 font-poppins">
                        Total Earnings
                    </p>
                </div>
                <p className="mt-1 text-sm font-semibold text-emerald-600 font-poppins">
                    {formatCurrency(partner.totalEarnings)}
                </p>
            </div>

            <div className="text-right">
                <div className="flex items-center gap-2">
                    <MdAccessTime />
                    <p className="uppercase tracking-wide text-[10px] text-slate-400 font-poppins">
                        Pending
                    </p>
                </div>
                <p className="mt-1 text-sm font-semibold text-amber-500 font-poppins">
                    {formatCurrency(partner.pendingEarnings)}
                </p>
            </div>
        </div>

        <button
            className="ml-4 text-slate-400 hover:text-slate-600 shrink-0 bg-blue-100 rounded-full h-5 w-5"
            onClick={() => onSelect(partner)}
        >
            <svg
                className="w-3 h-3 ml-1"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
            >
                <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M9 5l7 7-7 7"
                />
            </svg>
        </button>
    </div>
);


const Performence = () => {
    const [loading, setLoading] = useState(true)
    const [search, setSearch] = useState("");
    const [sortBy, setSortBy] = useState("newest");
    const [summary, setSummary] = useState(null);
    const [partners, setPartners] = useState([]);
    const [selectedPartnerId, setSelectedPartnerId] = useState(null);
    const [coverLogo, setCoverLogo] = useState("");
    const [createdAt, setCreatedAt] = useState("");

    useEffect(() => {
        getPartnerDetails();
    }, []);

    const getPartnerDetails = async () => {
        setLoading(true)
        try {
            const response = await getPartnerAnalysis();
            if (response.error === false) {
                const apiData = response.data || {};
                setSummary(apiData.summary || null);
                setPartners(apiData.partners || []);
                setLoading(false)
            } else {
                console.log(response.message);
                setLoading(false)
            }
        } catch (err) {
            console.log("getPartnerAnalysis error:", err);
            setLoading(false)
        }
    };

    console.log("partners", partners);


    const handleSelectPartner = (partner) => {
        setSelectedPartnerId(partner._id);
        setCoverLogo(partner.bannerImage || "");
        setCreatedAt(partner.createdAt || "");
    };


    const getSummaryValue = (key) => {
        if (!summary) return "--";
        const value = summary[key] ?? 0;

        if (key === "totalRevenue" || key === "pendingAmount") {
            return formatCurrency(value);
        }
        return (Number(value) || 0).toLocaleString("en-IN");
    };


    const filteredPartners = useMemo(() => {
        let list = [...partners];

        if (search.trim()) {
            const q = search.toLowerCase();
            list = list.filter((p) => p.name?.toLowerCase().includes(q));
        }

        list.sort((a, b) => {
            if (sortBy === "newest") {
                return new Date(b.createdAt) - new Date(a.createdAt);
            }
            if (sortBy === "oldest") {
                return new Date(a.createdAt) - new Date(b.createdAt);
            }
            if (sortBy === "atoz") {
                return (a.name || "").localeCompare(b.name || "");
            }
            if (sortBy === "ztoa") {
                return (b.name || "").localeCompare(a.name || "");
            }
            return 0;
        });

        return list;
    }, [partners, search, sortBy]);


    if (selectedPartnerId) {
        return (
            <div className="bg-[#f3f5fb] rounded-2xl w-full shadow-lg p-3 h-[82vh] m-2 flex flex-col gap-4 overflow-hidden">
                <PartnerAnalysis
                    partnerId={selectedPartnerId}
                    setSelectedPartner={setSelectedPartnerId}
                    coverImage={coverLogo}
                    createdAt={createdAt}
                />
            </div>
        );
    }




    return (
        <div className="bg-[#f3f5fb] rounded-2xl w-full shadow-lg p-3 h-[82vh] m-2 flex flex-col gap-4 overflow-hidden">
            {(loading) && (
                <div className="">
                    <Loader loading={loading} />
                </div>
            )}

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3">
                {SUMMARY_CARD_CONFIG.map((card) => (
                    <SummaryCard
                        key={card.id}
                        title={card.title}
                        value={getSummaryValue(card.key)}
                        icon={card.icon}
                        accentClasses={card.accentClasses}
                    />
                ))}
            </div>


            <div className="flex flex-col md:flex-row gap-3 items-center">
                <div className="relative flex-1 w-full">
                    <input
                        type="text"
                        placeholder="Search name..."
                        className="w-full rounded-[8px] border border-slate-200 bg-white px-3 py-2 text-sm outline-none focus:ring-2 focus:ring-blue-100 focus:border-blue-400"
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                    />
                </div>


                <select
                    className="w-full md:w-40 rounded-[8px] border border-slate-200 bg-white px-3 py-2 text-[12px] outline-none focus:ring-2 focus:ring-blue-100 focus:border-blue-400 font-poppins"
                    value={sortBy}
                    onChange={(e) => setSortBy(e.target.value)}
                >
                    <option value="newest">Newest</option>
                    <option value="oldest">Oldest</option>
                    <option value="atoz">A to Z</option>
                    <option value="ztoa">Z to A</option>
                </select>
            </div>


            <div className="flex-1 overflow-y-auto space-y-3 pr-1">
                {filteredPartners.map((partner) => (
                    <PartnerCard
                        key={partner._id}
                        partner={partner}
                        onSelect={handleSelectPartner}
                    />
                ))}

                {filteredPartners.length === 0 && (
                    <p className="text-center text-sm text-slate-500 mt-4">
                        No partners found.
                    </p>
                )}
            </div>
        </div>
    );
};

export default Performence;